export default "__VITE_ASSET__BxXgCBQi__"